// extracted by mini-css-extract-plugin
module.exports = {"table-cell":"table-picker_table-cell__YZ_D8","table-container":"table-picker_table-container__ZAvrs"};